import React from "react";
import PracticalInfo from "../programacion/components/PracticalInfo";
import Footer from "../components/Footer";

const InfoPractica: React.FC = () => {
  return (
    <div className="w-full min-h-screen pt-28 md:pt-40 lg:pt-60 pb-16">
      <article>
        <PracticalInfo />
      </article>
      <Footer />
    </div>
  );
};

export default InfoPractica;
